import { BrowserRouter as Router, Route } from 'react-router-dom';
import Home from './layout/Home'
import ButtonComponent from './components/button/Button';
import LinkComponent from './components/link/Link';
import SkeletonComponent from './components/skeleton/Skeleton'
import SpinnerComponent from './components/spinner/Spinner';
import TextInputComponent from './components/text-input/TextInput';
import AvatarComponent from './components/avatar/Avatar';
import BadgeComponent from './components/badge/Badge';
import ImageComponent from './components/image/Image';
import SearchComponent from './components/search/Search';
import Header from './layout/Header';
import Footer from './layout/Footer';

const App = () => {
  return (
    <Router>
      <Header />
      <main>
      <Route path='/' exact component={Home} />
      <Route path='/components/avatar' component={AvatarComponent} />
      <Route path='/components/badge' component={BadgeComponent} />
      <Route path='/components/button' component={ButtonComponent} />
      <Route path='/components/image' component={ImageComponent} />
      <Route path='/components/link' component={LinkComponent} />
      <Route path='/components/search' component={SearchComponent} />
      <Route path='/components/skeleton' component={SkeletonComponent} />
      <Route path='/components/spinner' component={SpinnerComponent} />
      <Route path='/components/text-input' component={TextInputComponent} />
      </main>
      <Footer />
    </Router>
  );
};

export default App;
